import { mapkitReady } from '../mapkit-loader.ts';

/**
 * The street address at a coordinate, for DISPLAY beside a dropped pin — so an
 * admin who tapped the map can see which address they tapped, and see it
 * change as they drag the pin. It is never stored: an assembly point is a named
 * coordinate, and an address here is the map's reading of that coordinate.
 *
 * MapKit JS's own geocoder, in the browser, through the same token and script
 * the map already loaded — no new vendor, no server call. `null` whenever it
 * cannot answer (MapKit unavailable, no result, an error), and the caller shows
 * nothing rather than a guess.
 */
export async function reverseAddress(latitude: number, longitude: number): Promise<string | null> {
  if (!(await mapkitReady())) return null;
  const mk = window.mapkit;
  if (!mk) return null;
  return new Promise((resolve) => {
    try {
      new mk.Geocoder().reverseLookup(new mk.Coordinate(latitude, longitude), (err, data) => {
        if (err) return resolve(null);
        const first = data?.results?.[0];
        resolve(first?.formattedAddress ?? first?.name ?? null);
      });
    } catch {
      resolve(null);
    }
  });
}
